import axios from 'axios';
import { useState } from 'react';
import { encrypt } from '../../utils/crypto';
import Swealert from '../../components/Swealert';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

/* const logo = 'https://readymadeui.com/signin-image.webp'; */
const logo = '/assets/logo-dimei.png';

export default function Login() {
  const [formData, setFormData] = useState({
    user: '',
    password: '',
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleClick = async (e) => {
    e.preventDefault();

    try {
      const respon = await axios.post('/login', formData, { withCredentials: true });
      console.log('Log Login:' + respon.data);

      // Guardar datos en sessionStorage inmediatamente
      sessionStorage.setItem('Token', respon.data.token);
      sessionStorage.setItem('rol', encrypt(respon.data.rolId));
      sessionStorage.setItem('rolName', encrypt(respon.data.rolName));
      sessionStorage.setItem('company', 1);

      sessionStorage.setItem('user', encrypt(respon.data.user));
      sessionStorage.setItem('name', encrypt(respon.data.name));
      sessionStorage.setItem('userId', encrypt(respon.data.userId));

      // Redirigir según el rol
      if (respon.data.rolName === 'Técnicos') {
        window.location.href = '/mantenimiento/clientes';
      } else if (respon.data.rolName === 'Jefe de Mantenimiento') {
        window.location.href = '/mantenimiento/historial';
      } else if (respon.data.rolName === 'Administrador') {
        window.location.href = '/dashboard';
      } else {
        // Todos los demás roles van a la pantalla de bienvenida
        window.location.href = '/bienvenida';
      }
    } catch (e) {
      if (e.message === 'Network Error') {
        Swealert({ ico: 'error', message: e.message });
      } else {
        Swealert({ ico: 'error', message: e.response?.data?.message || e.message });
      }
    }
  };

  return (
    <div className="font-[sans-serif]">
      <div className="grid lg:grid-cols-3 md:grid-cols-2 items-center gap-4 h-full">
        <div className="max-md:order-1 lg:col-span-2 md:h-screen w-full bg-[#000842] md:rounded-tr-xl md:rounded-br-xl lg:p-12 p-8">
          <img src={logo} className="lg:w-[50%] w-full h-full object-contain block mx-auto" alt="login" />

        </div>

        <div className="w-full p-6">
          <form onSubmit={handleClick}>
            <div className="mb-8">
              <h3 className="text-gray-800 text-3xl font-extrabold">DIMEI</h3>
            </div>

            <div>
              <label className="text-gray-800 text-[15px] mb-2 block">Usuario</label>
              <div className="relative flex items-center">
                <input
                  name="user"
                  type="text"
                  required
                  className="w-full text-sm text-gray-800 bg-gray-100 focus:bg-transparent px-4 py-3.5 rounded-md outline-blue-600"
                  placeholder="Usuario"
                  value={formData.user.toUpperCase()}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="mt-4">
              <label className="text-gray-800 text-[15px] mb-2 block">Contraseña</label>
              <div className="relative flex items-center">
                <input
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  required
                  className="w-full text-sm text-gray-800 bg-gray-100 focus:bg-transparent px-4 py-3.5 pr-12 rounded-md outline-blue-600"
                  placeholder="***********"
                  value={formData.password}
                  onChange={handleChange}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 text-gray-500 hover:text-gray-700 focus:outline-none"
                >
                  {showPassword ? (
                    <EyeSlashIcon className="h-5 w-5" />
                  ) : (
                    <EyeIcon className="h-5 w-5" />
                  )}
                </button>
              </div>
            </div>

            <div className="mt-8">
              <button
                type="submit"
                className="w-full py-3 px-6 text-sm tracking-wide rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none"
              >
                Iniciar sesión
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
